import { useTranslation } from 'react-i18next';

import { EmptyStateIllustration } from '~/assets/illustrations';

import { ErrorPage } from './ErrorPage';

export const RootErrorBoundary = ({ type }: { type: '404' | 'generic' }) => {
  const { t } = useTranslation('common');

  if (type === '404') {
    return (
      <ErrorPage
        illustration={<EmptyStateIllustration className="h-64" />}
        message={t(($) => $.error['404'].message)}
        title={t(($) => $.error['404'].title)}
      />
    );
  }

  return (
    <ErrorPage
      message={t(($) => $.error.generic.message)}
      title={t(($) => $.error.generic.title)}
    />
  );
};
